import { render, staticRenderFns } from "./liveInfo.vue?vue&type=template&id=fab73e26&scoped=true"
import script from "./liveInfo.vue?vue&type=script&lang=js"
export * from "./liveInfo.vue?vue&type=script&lang=js"
import style0 from "./liveInfo.vue?vue&type=style&index=0&id=fab73e26&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab73e26",
  null
  
)

export default component.exports